import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Alert } from 'antd';
const { Option } = Select;

const Login = ({ show, onHide, onLogin }) => {
    const [branches, setBranches] = useState([]);
    const [loginError, setLoginError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await fetch("https://live.jeyaagency.com/api/global/branch/list?");
                const data = await response.json();
                setBranches(data.branches);
            } catch (error) {
                console.error('Error fetching branches:', error);
            }
        };
        if (show) {
            fetchBranches();
        }
    }, [show]);

    const handleFinish = async (values) => {
        setLoginError('');
        setLoading(true);
        try {
            const response = await fetch('https://live.jeyaagency.com/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: values.username,
                    password: values.password,
                    branch_id: values.branch
                })
            });
            if (response.ok) {
                const data = await response.json();
                if(data.status_code==="0"){
                    localStorage.setItem('userToken', data.token);
                    const selectedBranch = branches.find(b => b.id === parseInt(values.branch));
                    const branchData = {
                        id: selectedBranch.id,
                        branch: selectedBranch.branch
                    };
                    localStorage.setItem('selectedBranch', JSON.stringify(branchData));
                    localStorage.setItem('userBranch', JSON.stringify(branchData));
                    localStorage.setItem('userId', data.user_details.id);
                    onLogin({ ...data, branch: branchData });
                } else {
                    setLoginError(data.message);
                }
            } else {
                setLoginError('Invalid credentials or branch selection');
            }
        } catch (error) {
            setLoginError('Login failed. Please try again.');
            console.error('Login failed:', error);
        }
        setLoading(false);
    };

    return (
        <Modal
            open={show}
            onCancel={onHide}
            footer={null}
            title="Login"
            centered
            destroyOnClose
        >
            {loginError && <Alert message={loginError} type="error" showIcon style={{ marginBottom: 16 }} />}
            <Form layout="vertical" onFinish={handleFinish} autoComplete="off">
                <Form.Item label="Username" name="username" rules={[{ required: true, message: 'Please enter your username' }]}> 
                    <Input autoFocus />
                </Form.Item>
                <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please enter your password' }]}> 
                    <Input.Password />
                </Form.Item>
                <Form.Item label="Branch" name="branch" rules={[{ required: true, message: 'Please select a branch' }]}> 
                    <Select
                        showSearch
                        placeholder="Select Branch"
                        filterOption={(input, option) =>
                            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {branches.map((branch) => (
                            <Option key={branch.id} value={branch.id}>{branch.branch}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>Login</Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default Login; 